module.exports = __webpack_public_path__ + "ptc_nakagawa_D1.b52d9b6a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/nakagawa/parent_to_child/ptc_nakagawa_D1.jpg
// module id = mK2P
// module chunks = 0